
import { Tag } from 'apprise-core/tag';
import { useTagClone } from 'apprise-frontend-tags/tag/context';
import { useRouting } from 'apprise-ui/utils/routing';
import { alltagsTabs } from '../list';
import { useTagModel } from './model';

export const tagSystemRoute = "/tags"


export const useTagRouting = () => {

    const { routeTo } = useRouting()

    const clone = useTagClone()

    const model = useTagModel()

    const self = {

        tagListRoute: () => `${tagSystemRoute}?tab=${alltagsTabs}`

        ,


        tagDetailRoute: (id?: string) => id ? `${tagSystemRoute}/${id}` : self.newTagRoute()

        ,


        newTagRoute: () => `${tagSystemRoute}/new`

        ,

        routeToTag: (tag: Tag | string) => routeTo(self.tagDetailRoute(typeof tag === 'string' ? tag : tag.id))

        ,

        routeToNewDetail: (model?:Tag) => {
            
            model ?   clone.setQuietly(s => s.clone = model) : clone.resetQuietly()
        
            routeTo(self.newTagRoute()) 
        
        }

      
        ,

        routeToTagList: () => routeTo(self.tagListRoute())

        ,

        nextTag: () => clone.get().clone ?? model.newTag()


    }

    return self

}

